import {
  Table as FlowTable,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'flowbite-react';
import { ReactNode } from 'react';
import { Icon } from '@acme/assets';
import { twMerge } from 'tailwind-merge';
import { Pagination } from '../pagination';

export interface TableSortedInfo {
  field: string;
  order: 'descend' | 'ascend' | null | undefined;
}

export type TableColumnProps<T = object> = {
  id: string | number;
  title: ReactNode;
  dataIndex: string;
  width?: number | string;
  className?: string;
  sorter?: boolean;
  render?: (value: any, entity: T) => ReactNode;
};

export type TableProps<T> = {
  keyIndex: string;
  columns: TableColumnProps<T>[];
  data: T[];
  loading?: boolean;
  className?: string;
  pagination?: {
    currentPage: number;
    pageSize: number;
    totalCount: number;
    onPageChange: (page: number) => void;
  };
};

export const Table = <T extends object = object>(props: TableProps<T>) => {
  return (
    <div className={twMerge('border rounded-lg relative', props.className)}>
      <div className="overflow-x-auto">
        <FlowTable hoverable>
          <TableHead>
            <TableRow>
              {props.columns.map((item) => {
                return (
                  <TableHeadCell
                    key={item.id}
                    className={twMerge(item.sorter && 'cursor-pointer')}
                  >
                    <div className="flex items-center gap-1">
                      {item.title}
                      {item.sorter && <Icon name="chevron-sort" size={10} />}
                    </div>
                  </TableHeadCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {props.data.map((entity) => {
              return (
                <TableRow
                  key={entity[props.keyIndex as keyof T] as string}
                  className="text-gray-900 text-sm border-b last:border-b-none border-gray-70"
                >
                  {props.columns.map((config) => {
                    const value = entity?.[config.dataIndex as keyof T] as any;

                    return (
                      <TableCell
                        key={config.id}
                        width={config?.width}
                        className={config?.className}
                      >
                        {config?.render?.(value, entity) || value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </FlowTable>
      </div>

      {props.pagination && (
        <Pagination
          className="px-6 py-4"
          onPageChange={() => {
            console.log();
          }}
          pageNumber={props.pagination?.currentPage}
          pageSize={props.pagination?.pageSize}
          totalCount={props.pagination.totalCount}
        />
      )}
    </div>
  );
};
